import { render } from "./BookFacility.vue?vue&type=template&id=2a93e382&scoped=true"
import script from "./BookFacility.vue?vue&type=script&lang=js"
export * from "./BookFacility.vue?vue&type=script&lang=js"

import "./BookFacility.vue?vue&type=style&index=0&id=2a93e382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a93e382"]])

export default __exports__